import React from 'react';
import podcasts from '../../../assets/images/resources_screen/podcasts.jpg';
import { motion } from 'framer-motion';

const Podcast = () => {
  return (
    <div
      id="podcast"
      className="w-full flex flex-col gap-4 sm:gap-6 md:gap-10 max-w-[1280px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10"
    >
      <motion.div
        initial={{ opacity: 0, y: 200 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        viewport={{ once: true, amount: 0.4 }}
        className="w-full rounded-2xl md:rounded-[50px] p-6 md:px-14 md:pt-10 md:pb-16 bg-[#EC008C]"
      >
        <h2 className="text-[48px] sm:text-[60px] 3xl:text-[75px] text-white font-bold leading-tight lg:ml-6 mb-4 md:mb-0">
          Podcast
        </h2>
        <div className="flex flex-col-reverse md:flex-row md:justify-between gap-4 md:gap-10 w-full">
          <div className="flex flex-col gap-4 flex-1 lg:ml-6">
            <h4 className="text-[28px] sm:text-[36px] text-white font-bold leading-tight">
              The GuidePost Alaska Parent Show
            </h4>
            <p className="text-white text-lg 2xl:text-xl">
              Welcome to the Guidepost Alaska Show! Recorded in clinic in
              Wasilla, Alaska from our beautiful new pediatric clininc. In this
              episode parents will be introduced to Guidepost's newest
              occupational therapist, Ms. MaryAnn. Tune in to learn how
              continuous and dedicated therapy time with occupational therapists
              really does change the brain of your child. MaryAnn will share to
              hear three tips and tricks for this summer to prepare your child
              for the next school year and make the best use of summertime fun.
              Find us a www.guidepostpediatrics.com.
            </p>
            <a
              href="https://www.youtube.com/@GuidepostPediatric"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p className="text-sm md:text-lg 2xl:text-xl text-white font-semibold border-[3px] md:w-fit border-white hover:bg-primary hover:border-[#764D99] rounded-md py-1 px-4 transition-all duration-300 transform hover:scale-105">
                Listen to the Podcast
              </p>
            </a>
          </div>
          <div className="flex-1 flex md:justify-end">
            <img
              src={podcasts}
              alt="listening"
              className="md:max-h-[350px] object-contain rounded-[20px] [clip-path:inset(1px)]"
            />
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Podcast;
